<template>
  <CSidebar 
    fixed 
    :class="selectedRole"
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/dashboard">
      <!--CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      /-->
      <img src="@/assets/images/liberty-resort-white.png" class="img-fluid" alt="LibertyResort">
    </CSidebarBrand>
    <template v-if="isDisplayRoles">
      <!-- FIXME: デザイン修正 -->
      <CSelect
        class="mx-3 mt-3 slt_bg roleSelect"
        :class="selectedRole"
        :value.sync="selectedRole"
        :options="ownRoles"
        @change="onRoleSelected()"
      />
    </template>

    <CRenderFunction
      flat
      :content-to-render="navDatas"
    />

    <!-- <CRenderFunction flat :content-to-render="$options.nav_operator_admin" v-if="getRole('liberty_operator_admin')" />
    <CRenderFunction flat :content-to-render="$options.nav_operation" v-else-if="getRole('liberty_operator')" />
    <CRenderFunction flat :content-to-render="$options.nav" v-else /> -->

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'
import nav_operation from './_nav.operator'
import nav_operator_admin from './_nav.operator.admin'

const ROLE = {
  ADMIN: "liberty_operator_admin",
  OPERATOR: "liberty_operator",
  MEMBER: "liberty_member",
};

export default {
  name: 'TheSidebar',
  nav,
  nav_operation,
  nav_operator_admin,
  data() {
    return {
      /** アカウントが使用可能なルート情報 */
      routerData: {},
      /** 選択中ロール */
      selectedRole: "",
    };
  },
  created() {
    // ルート情報設定用に、選択中ロールに初期ロールを設定する
    this.selectedRole = this.initialRole;
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },

    navDatas() {
      // 選択中のロールでルート情報更新
      this.updateRouterData(this.selectedRole);

      const menuDataStructure = [
        {
          _name: "CSidebarNav",
          _children: this.routerData,
        },
      ];

      return menuDataStructure;
    },

    /** ログイン中のアカウントが所属するロールリスト */
    ownRoles() {
      // ロールリスト
      let roles = [];

      // アカウントに設定済みのロールリストを作成
      for (const [key, value] of Object.entries(ROLE)) {
        // アカウントに未設定のロールはスキップ
        if (!this.$keycloak.realmAccess.roles.includes(value)) continue;

        // NOTE: ビルドエラー回避のためkeyを使用
        key;

        // 表示ラベルを取得
        const label = this.getRoleLabel(value);

        // アカウントに設定済みのロールをリストに追加
        roles.push({ value: value, label: label });
      }

      //
      return roles;
    },

    /** ロールリストを表示するか？ */
    isDisplayRoles() {
      // ロールが2件以上あれば表示
      return 1 < this.ownRoles.length;
    },
    /** 表示用の初期ロールを取得 */
    initialRole() {
      // アカウントのロールリスト
      const roles = this.$keycloak.realmAccess.roles;

      // 優先度に応じたロールを返す
      if (roles.includes(ROLE.ADMIN)) return ROLE.ADMIN;
      if (roles.includes(ROLE.OPERATOR)) return ROLE.OPERATOR;
      if (roles.includes(ROLE.MEMBER)) return ROLE.MEMBER;

      // 該当するロールがなければMEMBERを返す
      return ROLE.MEMBER;
    },
  },
  methods: {
    // getRole: function(navRole){
    //   const login_roles = this.$keycloak.realmAccess.roles;
    //   return login_roles.includes(navRole);
    // }    

    /** 選択中ロールに応じたサイドメニューを表示する */
    onRoleSelected() {
      // 選択中ロール
      const selectedRole = this.selectedRole;

      // ルート情報更新
      this.updateRouterData(selectedRole);
    },

    /** ルート情報更新 */
    updateRouterData(selectedRole) {
      // 選択中のロールによってルート情報を設定
      let allRouterDatas;

      switch (selectedRole) {
        case ROLE.ADMIN:
          allRouterDatas = nav_operator_admin;
          break;
        case ROLE.OPERATOR:
          allRouterDatas = nav_operation;
          break;
        case ROLE.MEMBER:
          allRouterDatas = nav;
          break;
        default:
          allRouterDatas = nav;
          break;
      }
      // アカウントが所属するロールが使用できるルート情報に更新する
      this.routerData = allRouterDatas
    },

    /**
     * ロールの表示ラベルを取得
     * @param value
     */
    getRoleLabel(value) {
      // 表示ラベル
      let label;

      // ロールに応じた表示ラベルを取得
      switch (value) {
        case ROLE.ADMIN:
          label = "管理者";
          break;
        case ROLE.OPERATOR:
          label = "オペレータ";
          break;
        default:
          label = "一般";
          break;
      }

      // 表示ラベルを返す
      return label;
    },
  }
}
</script>
